import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LayoutModule } from '../../../../app/theme/layouts/layout.module';
import { SharedModule } from '../../../../app/freightconfirmation/app.sharemodule';
import { RouterModule } from '@angular/router';
import { DocumentsharedModule } from '../../../../app/documentshared/documentshared.module';
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
    TranslateLoader,
    TranslateModule,
    TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../../theme/home/translateConfig.service";
import { MainComponent } from './main.component';
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        LayoutModule,
        SharedModule,
        RouterModule,
        DocumentsharedModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
    ],
    declarations: [
        MainComponent
    ],
    exports: [
        MainComponent
    ],
    providers: [TranslateConfigService],
})

export class MainCommonModule { }
